export type FieldType = "text" | "email" | "tel";

export interface FieldConfig {
  id: string;
  label: string;
  type: FieldType;
  required?: boolean;
  placeholder?: string;
  /** How many grid columns this field spans (1 or 2). Default: 1 */
  span?: 1 | 2;
}

/**
 * Guest RFQ form fields.
 * To add a field: push a new entry here — the form renders them automatically.
 * span: 2 = full row width, span: 1 (default) = half row.
 */
export const GUEST_RFQ_FIELDS: FieldConfig[] = [
  {
    id: "firstName",
    label: "First Name",
    type: "text",
    required: true,
    placeholder: "First name",
    span: 1,
  },
  {
    id: "lastName",
    label: "Last Name",
    type: "text",
    required: true,
    placeholder: "Last name",
    span: 1,
  },
  {
    id: "email",
    label: "Email",
    type: "email",
    required: true,
    placeholder: "Email",
    span: 2,
  },
  {
    id: "company",
    label: "Company",
    type: "text",
    required: true,
    placeholder: "Company",
    span: 1,
  },
  {
    id: "phone",
    label: "Phone",
    type: "tel",
    required: false,
    placeholder: "Phone",
    span: 1,
  },
  {
    id: "street",
    label: "Street Address",
    type: "text",
    required: true,
    placeholder: "Street Address",
    span: 2,
  },
  {
    id: "city",
    label: "City",
    type: "text",
    required: true,
    placeholder: "City",
    span: 1,
  },
  {
    id: "state",
    label: "State",
    type: "text",
    required: true,
    placeholder: "State",
    span: 1,
  },
  {
    id: "zip",
    label: "ZIP Code",
    type: "text",
    required: true,
    placeholder: "ZIP Code",
    span: 1,
  },
];
